import React, { forwardRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { FaFacebook, FaGithub, FaPhone, FaEnvelope } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";

const Contact = forwardRef(({ darkMode, scrollToSection, servicesRef }, ref) => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [status, setStatus] = useState("");

    const isFormValid = formData.name.trim() !== "" && formData.email.trim() !== "" && formData.message.trim() !== "";

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs
            .send(
                "service_h3l71px", // Service ID
                "template_p1axzxv", // Template ID
                formData,
                "HfGKfGi2cRNtOjCfE" // Public Key
            )
            .then(
                () => {
                    setStatus("Message sent successfully!");
                    setFormData({ name: "", email: "", message: "" });
                },
                () => {
                    setStatus("Failed to send message. Try again.");
                }
            );
    };

    return (
        <div ref={ref} id="contacts">
            <hr />
            <div className="container">
                <div className="row my-5 justify-content-center">
                    <div className="col-sm-12 col-md-10">
                        <div className={`w-100 py-4 mb-4 text-center ${darkMode ? "bg-darkMode" : "bg-lightMode"}`} style={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
                            <h2 className="responsic-HXText my-3 text-center">Get in touch</h2>
                        </div>
                    </div>

                    {/* Card Section */}
                    <div className="col-sm-12 col-md-5 mb-3">
                        <div className={`contact-card ${darkMode ? "bg-darkMode" : "bg-lightMode"}`}>
                            <h2>Ahmed Elgaml</h2>
                            <p className="responsive-Stext">
                                <FaEnvelope /> ahmedelgaml439@gmail.com
                            </p>
                            <p className="responsive-Stext">
                                <FaPhone /> +201021699255
                            </p>
                            <h4>Services:</h4>
                            <ul className="d-flex justify-content-center">
                                <button className="nav-link contact-service" onClick={() => scrollToSection(servicesRef)}>
                                    <li className="responsive-Stext">Websites</li>
                                </button>
                                <button className="nav-link contact-service" onClick={() => scrollToSection(servicesRef)}>
                                    <li className="responsive-Stext">Branding</li>
                                </button>
                                <button className="nav-link contact-service" onClick={() => scrollToSection(servicesRef)}>
                                    <li className="responsive-Stext">Ecommerce</li>
                                </button>
                                <button className="nav-link contact-service" onClick={() => scrollToSection(servicesRef)}>
                                    <li className="responsive-Stext">Marketing</li>
                                </button>
                                <button className="nav-link contact-service" onClick={() => scrollToSection(servicesRef)}>
                                    <li className="responsive-Stext">Voice Over</li>
                                </button>
                            </ul>
                            <div className="social-icons">
                                <a href="https://www.facebook.com/AhmedD.ElGaml" target="_blank" rel="noreferrer">
                                    <FaFacebook />
                                </a>
                                <a href="https://www.instagram.com/ahmedd.elgaml/" target="_blank" rel="noreferrer">
                                    <FaInstagram />
                                </a>
                                <a href="https://wa.me/201021699255/" target="_blank" rel="noreferrer">
                                    <FaWhatsapp />
                                </a>
                                <a href="https://github.com/a7medelgaml" target="_blank" rel="noreferrer">
                                    <FaGithub />
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Form Section */}
                    <div className="col-sm-12 col-md-5 mb-3">
                        <form onSubmit={handleSubmit} className={`contact-form ${darkMode ? "bg-darkMode" : "bg-lightMode"}`}>
                            <div className="mb-3">
                                <input
                                    type="text"
                                    className={`form-control ${darkMode ? "dark-mode" : "light-mode"}`}
                                    id="name"
                                    name="name"
                                    placeholder="Your Name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <input
                                    type="email"
                                    className={`form-control ${darkMode ? "dark-mode" : "light-mode"}`}
                                    id="email"
                                    name="email"
                                    placeholder="Your Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <textarea
                                    className={`form-control ${darkMode ? "dark-mode" : "light-mode"}`}
                                    id="message"
                                    name="message"
                                    placeholder="Your Message"
                                    style={{ height: "100px" }}
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <button type="submit" className="btn btn-primary w-100" disabled={!isFormValid}>
                                Send Message
                            </button>

                            {status && <p className="mt-3 text-center">{status}</p>}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Contact;
